import { render, staticRenderFns } from "./ServicesManagement.vue?vue&type=template&id=10331f14&"
import script from "./ServicesManagement.vue?vue&type=script&lang=js&"
export * from "./ServicesManagement.vue?vue&type=script&lang=js&"
import style0 from "./ServicesManagement.vue?vue&type=style&index=0&id=10331f14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports